import { UUID_REGEX } from 'core/constants/regex';

/**
 * Extracts all UUIDs from text content.
 * UUIDs are expected to be in the format: <uuid>
 */
export const extractUuidsFromText = (text: string): string[] => {
  const uuids = new Set<string>();
  const regex = new RegExp(UUID_REGEX);
  let match: RegExpExecArray | null;

  while ((match = regex.exec(text)) !== null) {
    uuids.add(match[1]);
  }

  return Array.from(uuids);
};
